/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { factoryT, fields } from 'factory-t';
import { OperatorDto, OperatorDetailsDto } from './operatorsClient.typings';
import { AddressResource } from '../apiCommon.typings';
import { CashRegisterModelsCounts } from '../cashRegisterModels/cashRegisterModelsClient.typings';
import { OperatorCashBoxesStats } from '../cashBoxes/cashBoxesClient.typings';
import { COMPANIES_STATUSES } from '../companies/companiesClient.typings';

export const operatorDtoFactory = factoryT<OperatorDto>({
    taxNumber: (ctx) => 100326824 + ctx.index,
    name: (ctx) => `${ctx.index} NBA TECHNOLOGİES INTERNATİONAL" MƏHDUD MƏSULİYYƏTLİ CƏMİYYƏTİ`,
    companiesCount: (ctx) => 20 + ctx.index * 2,
    storesCount: 44,
    cashboxesCount: 88,
    cashRegisterModelCount: 50,
    cashRegisterCount: 33,
    stockDevicesCount: 10,
    status: fields.sequence([...COMPANIES_STATUSES]),
});

export const legalAddressFactory = factoryT<AddressResource>({
    region: 'BAKI ŞƏHƏRİ BİNƏQƏDİ RAYONU',
    locality: null,
    city: 'BAKI ŞƏHƏRİ BİNƏQƏDİ RAYONU',
    postCode: '1130',
    street: 'HEYDƏR HÜSEYNOV',
    building: '11A',
});

export const cashRegisterModelsFactory = factoryT<CashRegisterModelsCounts>({
    registration: 3,
    active: 6,
    eliminated: 0,
    attestation: 2,
    reattestation: 1,
});

export const operatorDetailsFactory = factoryT<OperatorDetailsDto>({
    taxNumber: (ctx) => `100326824${ctx.index}`,
    name: 'NBA TECHNOLOGİES INTERNATİONAL" MƏHDUD MƏSULİYYƏTLİ CƏMİYYƏTİ',
    storeCount: 33,
    companiesCount: 11,
    cashRegistersCount: 123,
    fullAddress: 'BAKI ŞƏHƏRİ BİNƏQƏDİ RAYONU BAKI ŞƏHƏRİ BİNƏQƏDİ RAYONU HEYDƏR HÜSEYNOV 11A',
    registrationDate: `${new Date().toISOString()}`,
    legalAddress: legalAddressFactory.item(),
    cashRegisterModels: cashRegisterModelsFactory.item(),
    taxpayerStatus: 'ACTIVE',
    stockDevicesCount: 8,
});

export const operatorCashBoxesStatsFactory = factoryT<OperatorCashBoxesStats>({
    states: {
        active: 9,
        blocked: 9,
        inactive: 13,
        notBlocked: 10,
        offline: 19,
        online: 22,
    },
    statuses: {
        registration: 5,
        active: 6,
        blocked: 4,
        reset: 2,
        broken: 0,
        service: 0,
        eliminated: 1,
    },
    types: {
        temporary: 2,
        primary: 18,
    },
    timers: {
        correct: 38,
        incorrect: 3,
    },
    certificates: {
        valid: 15,
        expired: 3,
    },
});
